import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PUBLIC_URL = process.env.PUBLIC_URL || '';
const CUSTOMER_MANIFEST_PATH = `${PUBLIC_URL}/manifest.json`;
const ADMIN_MANIFEST_PATH = `${PUBLIC_URL}/manifest-admin.json`;

function AdminPWAConfig() {
  const location = useLocation();

  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith('/admin');
    const manifestPath = isAdminRoute ? ADMIN_MANIFEST_PATH : CUSTOMER_MANIFEST_PATH;
    const themeColor = isAdminRoute ? '#1e293b' : '#000000';
    const title = isAdminRoute ? 'IVA Admin Panel' : 'إيفا للعدسات';

    const manifestLink = document.querySelector('link[rel="manifest"]');
    if (manifestLink) {
      manifestLink.setAttribute('href', manifestPath);
    }

    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', themeColor);
    }

    document.title = title;
  }, [location.pathname]);

  return null;
}

export default AdminPWAConfig;